import {DisposalSet, select} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import Splide from '@splidejs/splide';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('cbdce-card-slider', (fragmentEl, config, meta) => {
    if(!document.body.classList.contains('has-edit-mode-menu')) {
        const sliderEl = select<HTMLDivElement>(fragmentEl, '.splide.cbdce-card-slider__slider-container');
        const splide = new Splide(sliderEl, {
            type: 'slide',
            gap: 24,
            pagination: false,
            fixedWidth: 'fit-content',
            perMove: 4,
            arrows: false,
            breakpoints: {
                1000: {
                    perMove: 2
                },
                768: {
                    perMove: 1
                },
            }
        });
        splide.mount();
        gc.register(() => splide.destroy());
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
